export default __webpack_public_path__ + "static/media/noResultsTrainings.0f96bef4.svg";